import {api, getCompetition} from 'app/services/api';
import {changeHeaderText} from 'app/actions/headerActions';
import {catchDataError, checkApiRedirect, RedirectException} from 'app/helpers/apiHelpers';
import {updateHistory} from 'app/actions/historyActions';
import {updateHttpError} from 'app/components/error/ErrorHandlerActions';

const getLeagueSpectators = (leagueSlug, seasonSlug = 'current') => {
  const request = `/competitions/${leagueSlug}/seasons/${seasonSlug}/spectators`;
  return api.get(request);
};

function updateLeague(data) {
  return {
    type: 'LEAGUE_SPECTATORS_META_LEAGUE_UPDATE',
    data,
  };
}

function updateSpectators(data) {
  return {
    type: 'LEAGUE_SPECTATORS_UPDATE',
    data,
  };
}

function fetchingSpectators() {
  return {
    type: `LEAGUE_SPECTATORS_FETCHING`,
  };
}

function setLeagueHeader(dispatch, league, seasonSlug) {
  const competitionSeasonName = seasonSlug ? `${league.name} ${league.season.name}` : league.name;
  const parent = {
    name: competitionSeasonName,
    entity: 'league',
    slugs: {
      leagueSlug: league.slug,
      seasonSlug: seasonSlug,
    },
  };

  dispatch(
    changeHeaderText({
      title: 'Zuschauer',
      parent,
    })
  );
}

function fetchLeagueSpectatorsSSR(leagueSlug, seasonSlug) {
  return async function (dispatch, getState) {
    const response1 = getCompetition(leagueSlug, seasonSlug).then(response => {
      const league = response.data;
      checkApiRedirect(league.slug, leagueSlug, league.season, seasonSlug, getState, league.active);
      dispatch(updateHistory('undefined', {store: 'LeagueSpectatorsPage', data: {metaLeague: league}}));
      setLeagueHeader(dispatch, league, seasonSlug);
    });

    const response2 = getLeagueSpectators(leagueSlug, seasonSlug).then(response => {
      dispatch(
        updateHistory('undefined', {
          store: 'LeagueSpectatorsPage',
          data: {items: response.data, isFetching: false},
        })
      );
    });

    try {
      return await Promise.all([response1, response2]);
    } catch (error) {
      if (error instanceof RedirectException) {
        throw error;
      } else {
        const errorData = catchDataError(error);
        dispatch(updateHttpError(errorData));
      }
    }
  };
}

function fetchLeagueSpectators(leagueSlug, seasonSlug, dispatchRedux) {
  return function (dispatch, state) {
    if (state.metaLeague && state.items.length) {
      setLeagueHeader(dispatchRedux, state.metaLeague, seasonSlug);
      return;
    }
    if (state.error) {
      return;
    }

    const response1 = getCompetition(leagueSlug, seasonSlug).then(response => {
      const league = response.data;
      checkApiRedirect(league.slug, leagueSlug, league.season, seasonSlug, null, league.active);
      dispatch(updateLeague(league));
      setLeagueHeader(dispatchRedux, league, seasonSlug);
    });
    dispatch(fetchingSpectators());
    const response2 = getLeagueSpectators(leagueSlug, seasonSlug).then(response => {
      dispatch(updateSpectators(response.data));
    });

    return Promise.all([response1, response2]).catch(error => {
      if (error instanceof RedirectException) {
        throw error;
      } else {
        const errorData = catchDataError(error);
        dispatchRedux(updateHttpError(errorData));
      }
    });
  };
}

export {fetchLeagueSpectators, fetchLeagueSpectatorsSSR};
